import { Quill } from '@vueup/vue-quill';

/* eslint-disable @typescript-eslint/no-explicit-any */

const Embed = Quill.import('blots/embed') as unknown as {
  new(...args: any[]): any;
  prototype: any;
  create?: (value?: unknown) => HTMLElement;
  formats?: (node: HTMLElement) => any;
};

const Parchment = Quill.import('parchment') as any;

export interface UserMentionValue {
  id: string | number;
  type?: string;
  text?: string;
}

export default class UserMentionBlot extends Embed {
  static blotName = 'user-mention';

  static className = 'user-mention';

  static tagName = 'SPAN';

  static scope = Parchment.Scope.INLINE_BLOT;

  static create(value?: unknown): HTMLElement {
    const baseCreate = (Embed as any).create as (this: any, valueParameter?: unknown) => HTMLElement | undefined;
    const node = baseCreate?.call(this, value) ?? document.createElement((this as any).tagName ?? 'SPAN');

    const v = (value ?? {}) as Partial<UserMentionValue>;
    if (v.type != null) node.setAttribute('data-user-type', String(v.type));
    if (v.id != null) node.setAttribute('data-user-id', String(v.id));
    if (v.text != null) node.innerText = String(v.text);

    return node;
  }

  static formats(node: HTMLElement) {
    return {
      type: node.getAttribute('data-user-type') ?? '',
      id: node.getAttribute('data-user-id') ?? '',
      text: node.innerText,
    };
  }

  format(name: string, value?: unknown): void {
    if (name === (this.constructor as typeof UserMentionBlot).blotName && value && typeof value === 'object') {
      const v = value as Partial<UserMentionValue>;
      const el = this.domNode as HTMLElement;
      if (v.type != null) el.setAttribute('data-user-type', String(v.type));
      if (v.id != null) el.setAttribute('data-user-id', String(v.id));
      if (v.text != null) el.innerText = String(v.text);
    } else {
      super.format(name, value);
    }
  }
}
